module.exports = __webpack_public_path__ + "static/media/Simple_world_map.0a8dd18d.svg";